<div (clickOutside)="close()">
  <app-icon-button
    [icon]="getIcon()"
    [color]="ButtonColorEnum.white"
    (clickFunc)="toggle()"
    [loading]="loading"
  ></app-icon-button>

  <div class="notifications-container">
    <ng-container *ngFor="let notification of notifications; let i = index">
      <div *ngIf="isOpen" class="notification">
        <div class="message">
          <img
            *ngIf="!notification.loading"
            [src]="getNotificationIconByType(notification.type)"
            class="icon"
          />
          <span *ngIf="!notification.loading">{{ notification.message }}</span>
          <img
            *ngIf="!notification.loading && notification.path"
            (click)="notificationRedirect(notification.path)"
            src="assets/icons/redirect.svg"
            class="icon-close"
          />
          <img
            *ngIf="!notification.loading"
            src="assets/icons/close-notification.svg"
            class="icon-close"
            (click)="markAsRead(notification.id)"
          />
          <div *ngIf="notification.loading" class="loading-container">
            <div class="loading-animation"></div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
